<nb-card *ngIf="teams && availableUsers" [nbSpinner]="loading" nbSpinnerStatus="primary" class="card-box">
    <nb-card-header class="content-header">
        <svg class="icon" xmlns="http://www.w3.org/2000/svg" width="18" height="20.906" viewBox="0 0 18 20.906" nbTooltip="{{'common.share-printer' | translate}}">
            <path id="Kształt_1182" data-name="Kształt 1182" class="cls-1" d="M1334,386.98h-2.58a1,1,0,0,0-1,1h0a1,1,0,0,0,1,1H1334a1,1,0,0,1,1,1V398a1,1,0,0,1-1,1h-12a1,1,0,0,1-1-1v-8.012a1,1,0,0,1,1-1h2.58a1,1,0,0,0,1-1h0a1,1,0,0,0-1-1H1322a3,3,0,0,0-3,3V398a3,3,0,0,0,3,3h12a3,3,0,0,0,3-3v-8.012A3,3,0,0,0,1334,386.98Zm-5.29-6.6a1,1,0,0,0-1.4,0l-3,2.9a1,1,0,0,0,1.27,1.545,0.724,0.724,0,0,0,.11-0.1l1.31-1.271v9.9a1,1,0,1,0,2,0v-9.851l1.29,1.3a1,1,0,0,0,1.41.006c0.01,0,.01,0,0.01-0.006a1.012,1.012,0,0,0,.01-1.416c-0.01,0-.01,0-0.01,0Z" transform="translate(-1319 -380.094)" />
        </svg>
        <span class="title">{{'common.share-printer' | translate}}</span>
        <nb-icon class="close" icon="close-outline" (click)="cancel()"></nb-icon>
    </nb-card-header>
    <nb-card-body class="content-body">
        <ng-container *ngIf="createNewTeam; then inputTeam; else selectTeam">
        </ng-container>
        <ng-template #inputTeam>
            <div class="input-box">
                <label name="teamName" for="teamName">{{'team.create-new-team' | translate}}</label>
                <button class="input-box__select-team-button" (click)="toggleInput()">
                    {{'common.select-from-list' | translate}}
                </button>
                <form [formGroup]="newTeamForm">
                    <input nbInput
                           fullWidth
                           type="text"
                           id="teamName"
                           name="teamName"
                           formControlName="teamName"
                           required
                           placeholder="{{'common.type-name' | translate}}"
                           [fieldSize]="'large'"
                           [status]="hasError('teamName') ? 'danger':'primary'" />
                    <app-control-messages [control]="getFormControl('teamName')"></app-control-messages>
                </form>
            </div>
        </ng-template>
        <ng-template #selectTeam>
            <div class="input-box">
                <label name="selectTeam" for="selectTeam">{{'team.choose-team' | translate}}</label>
                <button class="input-box__new-team-button" (click)="toggleInput()">
                    {{'team.new-team' | translate}}
                </button>
                <nb-select (selectedChange)="onSelectedTeamChange($event)"
                           [(selected)]="selectedTeam"
                           placeholder="{{'common.select-from-list' | translate}}"
                           fullWidth
                           id="selectTeam"
                           name="selectTeam"
                           size="large"
                           status="primary"
                           [disabled]="teams.length < 1">
                    <nb-option *ngFor="let team of teams; trackBy: trackByFn" [value]="team">{{team.name}}</nb-option>
                </nb-select>
            </div>
        </ng-template>
        <div class="input-box">
            <label name="selectUser" for="selectUser">{{'team.manage-users' | translate}}</label>
            <nb-select fullWidth 
                       multiple 
                       [(selected)]="selectedUserEmails" 
                       size="large" 
                       status="primary" 
                       placeholder="{{'common.choose-user' | translate}}">
                <nb-option id="selectUser"
                           name="selectUser"
                           [value]="user.email" 
                           *ngFor="let user of availableUsers; trackBy: trackByFn" 
                           [disabled]="!user.isActive">
                    <span class="select-text">
                        {{user.text}}
                    </span>
                </nb-option>
                <nb-option (click)="openOrganizationTab()">
                    <span class="select-text--organization">
                        {{'team.invite-user-to-your-organization' | translate}}
                    </span>
                </nb-option>
            </nb-select>
        </div>
    </nb-card-body>
    <nb-card-footer class="content-footer">
        <button nbButton [size]="'large'" [status]="'control'" [appearance]="'outline'"
                (click)="cancel()" tabindex="-1">
            {{'common.cancel' | translate}}
        </button>
        <button nbButton 
                [status]="'primary'" 
                [size]="'large'"
                (click)="save()"
                tabindex="-1"
                [disabled]="checkDisabled()">
            {{(createNewTeam ? 'common.create-and-share' : 'common.share') | translate}}
        </button>
    </nb-card-footer>
</nb-card>
